const apresentationcontent = [
{id:1,
title:"Keeper App",
img:"https://github.com/RamonFavero/ramonportfolio/blob/main/src/img/keeperapp.png?raw=true",
corpo:"Este foi um projeto simulando Google Keep para praticar o uso de UseState().",
repositorio:"https://github.com/RamonFavero/KeeperApp",
projeto:"https://ramonfavero.github.io/KeeperApp/",
buttonPTEN:"PÁGINA"
},
{id:3,
title:"To-Do List",
img:"https://github.com/RamonFavero/ramonportfolio/blob/main/src/img/todolist.png?raw=true",
corpo:"Esse é um projeto de lista de tarefas bem simples, ótimo para firmar o conhecimento em states, map e props.",
repositorio:"https://github.com/RamonFavero/todolist",
projeto:"https://ramonfavero.github.io/todolist/",
buttonPTEN:"PÁGINA"
},
{id:4,
title:"Sign Up App",
img:"https://github.com/RamonFavero/ramonportfolio/blob/main/src/img/signupapp.png?raw=true",
corpo:"Uma pagina de login/registro com a lógica feita apenas no front-end para fazer a leitura dos dados e permitir o login/registro.",
repositorio:"https://github.com/RamonFavero/signupapp",
projeto:"https://ramonfavero.github.io/signupapp",
buttonPTEN:"PÁGINA"
},
{id:5,
title:"Taskify",
img:"https://github.com/RamonFavero/ramonportfolio/blob/main/src/img/taskify.png?raw=true",
corpo:"Meu primeiro projeto feito com TypeScript. ",
repositorio:"https://github.com/RamonFavero/taskify",
projeto:"https://ramonfavero.github.io/taskify/",
buttonPTEN:"PÁGINA"
    },
    {id:6,
title:"Spotflix",
img:"https://github.com/RamonFavero/ramonportfolio/blob/main/src/img/spotflix.png?raw=true",
corpo:"Primeira vez usando Typescript retirando dados de uma API aberta.",
repositorio:"https://github.com/RamonFavero/spotflix",
projeto:"https://ramonfavero.github.io/spotflix/",
buttonPTEN:"PÁGINA"
    },

]

export default apresentationcontent